import { Controller } from "@hotwired/stimulus"
import Typed from "typed.js"

export default class extends Controller {
  static values = {
    strings: Array,
    typeSpeed: { type: Number, default: 50 },
    backSpeed: { type: Number, default: 50 },
    loop: { type: Boolean, default: false },
    showCursor: { type: Boolean, default: true },
    cursorChar: { type: String, default: "|" }
  }

  connect() {
    this.typed = new Typed(this.element, {
      strings: this.stringsValue,
      typeSpeed: this.typeSpeedValue,
      backSpeed: this.backSpeedValue,
      loop: this.loopValue,
      showCursor: this.showCursorValue,
      cursorChar: this.cursorCharValue
    })
  }

  disconnect() {
    this.typed.destroy()
  }
} 